var root = require('./_root');

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;



//////////////////
// WEBPACK FOOTER
// ../js/~/lodash/_Symbol.js
// module id = 92
// module chunks = 0